import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AsaasRepository } from 'data/AsaasRepository'

export type BoletoBillTo = 'patient' | 'responsible'

interface GenerateBoletoInput {
	paymentId: string
	// Who the boleto is issued to. Omitted -> API defaults to the legal
	// representative when the patient has one.
	billTo?: BoletoBillTo
}

export function useGenerateAsaasBoletoMutation() {
	const client = useQueryClient()
	const toast = useToast()

	return useMutation({
		mutationFn: ({ paymentId, billTo }: GenerateBoletoInput) =>
			new AsaasRepository().generateBoleto(paymentId, billTo),
		onSuccess: () => {
			toast({
				status: 'success',
				title: 'Boleto gerado',
			})
			client.invalidateQueries({ queryKey: ['payments'] })
			client.invalidateQueries({ queryKey: ['treatment-payments'] })
		},
		onError: (error) =>
			toast({
				status: 'error',
				title: 'Erro ao gerar boleto',
				description: error.message,
			}),
	})
}
